import { EstimateDetailItemCard } from './estimateResult/estimateDetailItemCard';
import { InsuranceApplyResultCard } from './estimateResult/insuranceApplyResultCard';
import { NoInsuranceCard } from './estimateResult/noInsuranceCard';
import { RepairServiceEstimateField } from './estimateResult/repairServiceEstimateField';
import {
  EstimateDetailInfoType,
  EstimateInfoType,
  InsuranceResultInfoType,
} from '@/types/bodyAndPaint';

interface EstimateResultInfoFieldProps {
  onOpenInsuranceModal: () => void;
  onCheckImage: () => void;
  insuranceResultInfo?: InsuranceResultInfoType;
  estimateInfo: EstimateInfoType;
  detailList: EstimateDetailInfoType;
}
export const EstimateResultInfoField = ({
  onOpenInsuranceModal,
  onCheckImage,
  insuranceResultInfo,
  estimateInfo,
  detailList,
}: EstimateResultInfoFieldProps) => {
  return (
    <div className={'estimate-result-info-field'}>
      <EstimateDetailItemCard info={detailList} onClick={onCheckImage} />
      {insuranceResultInfo ? (
        <InsuranceApplyResultCard info={insuranceResultInfo} />
      ) : (
        <NoInsuranceCard onClick={onOpenInsuranceModal} />
      )}
      <RepairServiceEstimateField info={estimateInfo} />
    </div>
  );
};
